vBumpUV = uv;
vPositionW = worldPosition.xyz;
vNormalW = normalize((modelMatrix * vec4(normal, 0.0)).xyz);

vec3 origin = (modelMatrix * vec4(0.0, 0.0, 0.0, 1.0)).xyz;
vec3 upWorld = normalize(-topFaceNormal);

// set vHeight which is the height of the fragment in world space along the upWorld axis
// This is used to determine the height a pixel along the top of a D4 die
vHeight = dot(vPositionW - origin, upWorld);
